
const { log } = console
const { getRandomToolbar } = require('./utils/random.js')
const uuid = require('./utils/uuid.js')

const {
  addStartingParts,
  setExposedVariables
} = require('./utils/load-scene-helpers.js')
const { findSpriteByName } = require('./utils/find-target.js')

function sanitizeToolbar (toolbar, availableGlitches, availableParts) {
  const toolbarSanitized = { glitches: [], parts: [] }
  if (toolbar.glitches) {
    toolbar.glitches.forEach(g => {
      const matchingGlitch = availableGlitches.find(
        glitch => glitch.id.toLowerCase() === g.toLowerCase()
      )
      if (matchingGlitch) {
        toolbarSanitized.glitches.push(matchingGlitch.id)
      }
    })
  }
  if (toolbar.parts) {
    toolbar.parts.forEach(p => {
      const matchingPart = availableParts.find(
        part => part.id.toLowerCase() === p.toLowerCase()
      )
      if (matchingPart) {
        toolbarSanitized.parts.push(matchingPart.id)
      }
    })
  }
  return toolbarSanitized
}
function sanitizeStartingGlitches (startingGlitches, availableGlitches) {
  const startingGlitchesSanitized = []
  if (startingGlitches) {
    startingGlitches.forEach(g => {
      const matchingGlitch = availableGlitches.find(
        glitch => glitch.id.toLowerCase() === g.glitchId.toLowerCase()
      )
      if (matchingGlitch) {
        startingGlitchesSanitized.push({ ...g, glitchId: matchingGlitch.id })
      }
    })
  }
  return startingGlitchesSanitized
}

function sanitizeStartingParts (startingParts, availableParts) {
  const startingPartsSanitized = []
  if (startingParts) {
    startingParts.forEach(p => {
      const matchingPart = availableParts.find(
        part => part.id.toLowerCase() === p.partId.toLowerCase()
      )
      if (matchingPart) {
        startingPartsSanitized.push({ ...p, partId: matchingPart.id })
      }
    })
  }
  return startingPartsSanitized
}

function sendAnalytics (id) {
  const pageTitle = document.title
  const pageLocation = window.location.href
  gtag('event', 'page_view', {
    page_title: pageTitle,
    page_location: pageLocation
  });
}

module.exports = function store (state, emitter) {
  emitter.on('load-scene', () => {
    log('load-scene')
    document.title = `${state.projectMetadata.title.toUpperCase()} - Makey Apps`
    if (!window.location.host.includes('localhost')) {
      sendAnalytics(state.projectMetadata.id)
    }
    emitter.emit('pause')
    emitter.emit('deselect-all')
    if (state.projectMetadata.persistentVariables) {
      state.projectMetadata.persistentVariables =
        state.projectMetadata.persistentVariables.map(pv => {
          const target = findSpriteByName(state.vm, pv.spriteName)
          if (target) {
            const variable = Object.values(target.variables).find(
              v => v.name === pv.variableName
            )
            if (variable) {
              pv.value = variable.value
            }
          }
          return pv
        })
    }
    state.glitchApplications = []
    if (state.sceneData.attemptRemoteLoad) {
      state.vm.downloadProjectId(`${state.projectMetadata.id}`)
    } else {
      state.vm.loadProject(state.sceneData)
    }
    state.vm.runtime.once('PROJECT_LOADED', () => {
      emitter.emit('setup-scene')
    })
  })

  emitter.on('setup-scene', () => {
    log('setup-scene')
    if (state.sceneMetadata.toolbar) {
      state.toolbar = sanitizeToolbar(
        state.sceneMetadata.toolbar,
        state.availableGlitches,
        state.availableParts
      )
    } else {
      state.toolbar = getRandomToolbar(
        state.availableGlitches,
        state.availableParts
      )
    }
    state.appliedGlitches = []
    state.addedParts = []
    state.sceneMetadata.startingParts = sanitizeStartingParts(
      state.sceneMetadata.startingParts,
      state.availableParts
    )
    state.sceneMetadata.startingGlitches = sanitizeStartingGlitches(
      state.sceneMetadata.startingGlitches,
      state.availableGlitches
    )
    addStartingParts(
      state.vm,
      state.sceneMetadata.startingParts,
      state.availableParts,
      state.addedParts
    ).then(results => {
      if (results && results.length) {
        for (let i = 0; i < results.length; i++) {
          const newName = state.sceneMetadata.startingParts[i].spriteName
          const addedPartEntry = state.addedParts.find(
            p => p.spriteName === results[i].sprite.name
          )
          addedPartEntry.spriteName = newName
          results[i].sprite.name = newName
        }
      }
      if (state.sceneMetadata.startingGlitches) {
        emitter.emit('apply-starting-glitches')
      }
      if (state.sceneMetadata.exposedVariables) {
        setExposedVariables(state.vm, state.sceneMetadata.exposedVariables)
      }
      if (state.sceneMetadata.spriteProperties) {
        emitter.emit('set-sprite-properties')
      }
      if (state.projectMetadata.persistentVariables) {
        state.projectMetadata.persistentVariables.forEach(v => {
          if (v.value || v.value === 0) {
            const target = findSpriteByName(state.vm, v.spriteName)
            const targetVariable = target.lookupOrCreateVariable(
              uuid(),
              v.variableName
            )
            targetVariable.value = v.value
          }
        })
      }
      emitter.emit('load-complete')
    })
  })
}
